import React from 'react';

const AddressVerificationForm = ({ onAddressSelection, isEnteredAddressCorrect, enteredAddress,  addressType, suggestedAddress, errors, onEditAddress, checkDupAddress, handleCloseAllDialog, onUseSelectedAddress, onBack, noActions, disabledAddressTypes }) => {
	return (
		<form className="verifyShippingAddressForm" id="verifyShippingAddressForm">
			<table className="formTableTypeA verifyNewShippingAddressTable" style={{ width: '100%' }}>
				<tbody>
					<tr>
						<td colSpan={2} style={{ textAlign: 'left' }}>
							<b>Your address as you entered it:</b>
						</td>
					</tr>
					<tr>
						<td style={{ borderBottom: '1px solid #999' }}>
							<input
								type="radio"
								name="whichAddress"
								onChange={onAddressSelection}
								defaultValue="asEntered"
								checked={isEnteredAddressCorrect === true}
								disabled={disabledAddressTypes && disabledAddressTypes.includes('asEntered')}
							/>
						</td>
						<td style={{ borderBottom: '1px solid #999', padding: 10 }}>
							<span id="enteredAddress1">{enteredAddress.address1 || enteredAddress.addressLine1}</span>
							<br />
							<span id="enteredAddress2">{enteredAddress.address2 || enteredAddress.addressLine2}</span>
							{(enteredAddress.address2 || enteredAddress.addressLine2) && <br />}
							<span id="enteredAddress3">{enteredAddress.address3 || enteredAddress.addressLine3}</span>
							{(enteredAddress.address3 || enteredAddress.addressLine3) && <br />}
							<span id="enteredCity">{enteredAddress.city}</span>, <span id="enteredState">{enteredAddress.state || enteredAddress.province}</span>&nbsp;
							<span id="enteredZip">{enteredAddress.zipCode || enteredAddress.postalCode}</span>
							<br />
							<span>{enteredAddress.country}</span>
							<br />
							{onEditAddress && (
								<a href="" onClick={onEditAddress.bind(this, 'asEntered')}>
									Edit Address
								</a>
							)}
						</td>
					</tr>
					{suggestedAddress && (
						<React.Fragment>
							<tr>
								<td colSpan={2} style={{ textAlign: 'left' }}>
									<b>
										{suggestedAddress.status && !suggestedAddress.responseObject
											? "Don't see a match?"
											: suggestedAddress.responseObject && suggestedAddress.responseObject.grouponecallerror
											? 'Invalid Address'
											: 'Here is what we found:'}
									</b>
								</td>
							</tr>
							{suggestedAddress.status && !suggestedAddress.responseObject ? (
								<tr>
									<td colSpan={2} style={{ textAlign: 'center', borderBottom: '1px solid #999' }}>
										This does not appear to be a valid address.
										<br />
										Please provide valid information.
									</td>
								</tr>
							) : (
								suggestedAddress.responseObject &&
								(suggestedAddress.responseObject.grouponecallerror ? (
									<tr>
										<td colSpan={2} className="text-left" style={{ padding: '0 65px' }}>
											<p className="red bold">
												The U.S. Portal Service doesn't recognize this address.
												<br />
												Please verify that you have the DELIVERY STREET ADDRESS in the FIRST line and any
												<br />
												PROJECT NAME in the SECOND line.
											</p>
										</td>
									</tr>
								) : (
									<tr>
										<td style={{ borderBottom: '1px solid #999' }}>
											<input
												type="radio"
												name="whichAddress"
												onChange={onAddressSelection}
												defaultValue="asCorrected"
												checked={isEnteredAddressCorrect === false}
												disabled={disabledAddressTypes && disabledAddressTypes.includes('asCorrected')}
											/>
										</td>
										<td style={{ borderBottom: '1px solid #999', padding: 10 }}>
											<span id="enteredAddress1">{suggestedAddress.responseObject.addressline1.trim()}</span>
											<br />
											<span id="enteredAddress2">{suggestedAddress.responseObject.addressline2.trim()}</span>
											{suggestedAddress.responseObject.addressline2.trim() && <br />}
											<span id="enteredAddress3">{suggestedAddress.responseObject.addressline3 || localStorage.getItem("address3Continue")}</span>
											{(suggestedAddress.responseObject.addressline3 || localStorage.getItem("address3Continue")) && <br />}
											<span id="enteredCity">{suggestedAddress.responseObject.city.trim()}</span>,{' '}
											<span id="enteredState">{suggestedAddress.responseObject.state.trim()}</span>
											&nbsp;
											<span id="enteredZip">{suggestedAddress.responseObject.postalcode.trim()}</span>
											<br />
											<span>
												{suggestedAddress.responseObject &&
													(suggestedAddress.responseObject.country.toUpperCase() === 'UNITED STATES OF AMERICA'
														? 'US'
														: suggestedAddress.responseObject.country.toUpperCase() === 'CANADA'
														? 'CA'
														: '')}
											</span>
											<br />
											{onEditAddress && (
												<a href="" onClick={onEditAddress.bind(this, 'asCorrected')}>
													Edit Address
												</a>
											)}
										</td>
									</tr>
								))
							)}
							{suggestedAddress.responseObject && suggestedAddress.responseObject.results && errors.length !== 0 && (
								<tr>
									<td colSpan={2} className="text-left" style={{ padding: '0 65px' }}>
										<p className="red bold">This is an invalid address. </p>
										{errors}
									</td>
								</tr>
							)}
						</React.Fragment>
					)}
				</tbody>
			</table>
			{!noActions && (
				<div className="actions">
					{onBack && (
						<button type="button" className="orangeButton" onClick={onBack}>
							Back
						</button>
					)}
					<div style={{display:'flex', flexDirection: 'column', marginTop:'-4%'}}>
				{checkDupAddress &&
					<p style={{textAlign:'-webkit-center', color:'red',marginLeft:'2px', fontWeight:'bold'}}>This address is already present in the {addressType ? addressType : 'Ship To'}  Address list. CONTINUE will select this address.</p>}
				{checkDupAddress && 
					<p style={{display:'flex',justifyContent:'center',marginTop:'auto'}}>
						{[checkDupAddress.ADDRESS1 && checkDupAddress.ADDRESS1,
         				 checkDupAddress.ADDRESS2 &&  checkDupAddress.ADDRESS2,
									checkDupAddress.ADDRESS3 && checkDupAddress.ADDRESS3,
									checkDupAddress.CITY && checkDupAddress.CITY,
									checkDupAddress.STATE && checkDupAddress.STATE,
									checkDupAddress.POSTALCODE && checkDupAddress.POSTALCODE,
         				 checkDupAddress.LOCATION && checkDupAddress.LOCATION].filter(Boolean).join(', ')
						}
							</p>
				}	
				{checkDupAddress && <div style={{display:'flex',justifyContent:'center'}}>
                          	<a className="blueButton" style={{textAlign:'-webkit-center'}} onClick={handleCloseAllDialog}>Continue</a>
                        </div>}	

				{!checkDupAddress && <button style={{marginTop:'20px'}} id="useSelectedAddress" type="button" onClick={onUseSelectedAddress}>
								Use Selected Address
				</button>}	
					</div>
				</div>
			)}
		</form>
	);
};

export default AddressVerificationForm;



// WEBPACK FOOTER //
// ./src/App/components/common/addressVerificationForm.jsx